import Vue from 'vue';
//配置路由
import VueRouter from 'vue-router'
Vue.use(VueRouter);
//1.创建组件
import Index from '@/views/index'
import Home from '@/views/home'
import Login from '@/views/login'
import NotFound from '@/views/404'
import UpdatePassword from '@/views/update-password'
import pay from '@/views/pay'
import register from '@/views/register'
import center from '@/views/center'
    import jixiaokaohe from '@/views/modules/jixiaokaohe/list'
    import yuangong from '@/views/modules/yuangong/list'
    import jixiaozhibiao from '@/views/modules/jixiaozhibiao/list'
    import bumen from '@/views/modules/bumen/list'
    import gonggaoxinxi from '@/views/modules/gonggaoxinxi/list'
    import gangwei from '@/views/modules/gangwei/list'
    import yuangongjixiao from '@/views/modules/yuangongjixiao/list'
    import shouhouyeji from '@/views/modules/shouhouyeji/list'
    import youxiaoyeji from '@/views/modules/youxiaoyeji/list'
    import gongsizhichu from '@/views/modules/gongsizhichu/list'
    import gongsi from '@/views/modules/gongsishouru/list'
    import shouruhuizong from '@/views/modules/shouruhuizong/list'
    import caozuorizhi from '@/views/modules/caozuorizhi/list'
    import yejipaihang from '@/views/modules/yejipaihang/list'

//2.配置路由   注意：名字
const routes = [{
    path: '/index',
    name: '首页',
    component: Index,
    children: [{
      // 这里不设置值，是把main作为默认页面
      path: '/',
      name: '首页',
      component: Home,
      meta: {icon:'', title:'center'}
    }, {
      path: '/updatePassword',
      name: '修改密码',
      component: UpdatePassword,
      meta: {icon:'', title:'updatePassword'}
    }, {
      path: '/pay',
      name: '支付',
      component: pay,
      meta: {icon:'', title:'pay'}
    }, {
      path: '/center',
      name: '个人信息',
      component: center,
      meta: {icon:'', title:'center'}
    }
      ,{
	path: '/yuangongjixiao',
        name: '业绩管理',
        component: yuangongjixiao
      }
      ,{
        path: '/shouhouyeji',
        name: '售后管理',
        component: shouhouyeji
        }
      ,{
        path: '/youxiaoyeji',
        name: '有效业绩',
        component: youxiaoyeji
      },{
        path: '/gongsizhichu',
        name: '支出管理',
        component: gongsizhichu
      },{
        path: '/gongsishouru',
        name: '收入管理',
        component: gongsi
      },{
        path: '/shouruhuizong',
        name: '收入汇总',
        component: shouruhuizong
      },{
        path: '/yejipaihang',
        name: '业绩排行',
        component: yejipaihang
      }
      ,{
	path: '/yuangong',
        name: '员工',
        component: yuangong
      }
      ,{
	path: '/jixiaozhibiao',
        name: '绩效指标',
        component: jixiaozhibiao
      }
      ,{
	path: '/bumen',
        name: '公司',
        component: bumen
      }
      ,{
	path: '/gonggaoxinxi',
        name: '公告信息',
        component: gonggaoxinxi
      }
      ,{
	path: '/gangwei',
        name: '岗位',
        component: gangwei
      },{
        path: '/caozuorizhi',
        name: '操作日志',
        component: caozuorizhi
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {icon:'', title:'login'}
  },
  {
    path: '/register',
    name: 'register',
    component: register,
    meta: {icon:'', title:'register'}
  },
  {
    path: '/',
    name: '首页',
    redirect: '/index'
  }, /*默认跳转路由*/
  {
    path: '*',
    component: NotFound
  }
]
//3.实例化VueRouter  注意：名字
const router = new VueRouter({
  mode: 'hash',
  /*hash模式改为history*/
  routes // （缩写）相当于 routes: routes
})

export default router;
